module.exports = __webpack_public_path__ + "static/media/windows.365c880d.svg";